module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1CBYPWR/images/9781439646151.jpg?1684515201155",
      "alt": "This image is the cover for the book Florence, Images of America"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Florence, Images of America\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("Join author and historian Carolyn Barske as she recounts the history of Florence, Alabama through the lens of over 200 vintage images.")])]), _c('br'), _c('p', [_vm._v("On the banks of the Tennessee River, below the once-formidable Muscle Shoals in northwest Alabama, sits the vibrant community of Florence. In the early 19th century, the Chickasaw Nation ceded lands to the US government, and in 1818 the Cypress Land Company held its first auction. The town grew quickly because of the efforts of the company's founders, which included Gen. John Coffee; John McKinley, who later sat on the US Supreme Court; and James Jackson, whose imported Thoroughbred horses became the bloodstock for some of Kentucky's finest racehorses. Schools, churches, hotels, and businesses soon filled the streets. For almost 200 years, the town of Florence has continued to grow, becoming home to the University of North Alabama and people like the \"Father of the Blues,\" W.C. Handy; Maud Lindsay, who operated the first free kindergarten in the state; and four governors in Edward A. O'Neal, Emmett O'Neal, Robert M. Patton, and Hugh McVay. ")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Carolyn Barske\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Historian Carolyn Barske of the University of North Alabama Public History Center has worked with the Muscle Shoals National Heritage Area, the Florence Lauderdale Public Library Digital Archives, and the University of North Alabama Collier Library Archives and Special Collections to select images and stories documenting the history of Florence.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Arcadia Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0